<template>
  <div class="rule-text-box">
    <template v-if="lang === 'en-US'">
      <h2 align="center">
        <strong>Checklist of Personal Information to Be Collected</strong>
      </h2>
      <p>&nbsp;</p>
      <p>
        In order to ensure the safe and stable operation of our products or
        services, we may collect your personal information as shown below:
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>1. </strong>&nbsp; <strong>Basic Information of User</strong>
      </p>
      <p>Name of Information: Name</p>
      <p>
        Application Purpose: Real-name authorization of individual, information
        requirements, data analysis, obtaining the information related to
        buyer’s order
      </p>
      <p>
        Application Scenario:&nbsp; Real-name authorization of individual for
        electronic signing and ticket booking, intent order, project release,
        big data analysis, display of exhibitor and exhibit information<em></em>
      </p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ten pieces of
        information have been collected
      </p>
      <p>&nbsp;</p>
      <p>Name of Information: Cellphone Number</p>
      <p>
        Application Purpose: Creating accounts, contacting users, analyzing
        data, obtaining the information related to buyer’s order, and promoting
        the enterprise
      </p>
      <p>
        Application Scenario:&nbsp; Initial sign-up of users, display of
        exhibitor and exhibit information, big data analysis, contacting for
        booth sales and electronic signing, ticket booking
      </p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Nine pieces of
        information have been collected
      </p>
      <p>&nbsp;</p>
      <p>Name of Information: Contact email</p>
      <p>
        Application Purpose: Obtaining the information related to buyer’s order,
        and promoting the enterprise
      </p>
      <p>
        Application Scenario:&nbsp; Display of exhibitor and exhibit information
        and project release
      </p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Eight pieces of
        information have been collected
      </p>
      <p>&nbsp;</p>
      <p>Name of Information: Address</p>
      <p>
        Application Purpose: Obtaining the information related to buyer’s order
      </p>
      <p>
        Application Scenario:&nbsp; Confirming the information related to
        buyer’s order
      </p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Two pieces of
        information have been collected
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p><strong>2. </strong><strong>User Identification</strong></p>
      <p>
        <strong>(1)</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>Identification of user as a natural person</strong>
      </p>
      <p>Name of Information: Type and number of badge</p>
      <p>Application Purpose: Real-name Auth</p>
      <p>Application Scenario:&nbsp; Electronic signing and ticket booking</p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Two pieces of
        information have been collected
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>(2)</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>Virtual identity and authentication information of user</strong>
      </p>
      <p>Name of Information: Account and password</p>
      <p>Application Purpose: Creating accounts</p>
      <p>
        Application Scenario:&nbsp; Initial creation of an account, login,
        retrieving and resetting the password
      </p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; One piece of
        information has been collected
      </p>
      <p>&nbsp;</p>
      <p><strong>3. </strong><strong>User Information during Use</strong></p>
      <p>
        <strong>(1)</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>Content of user services</strong>
      </p>
      <p>
        Name of Information: Browsing exhibitor and exhibit information by the
        user
      </p>
      <p>
        Application Purpose: Recommending exhibitors and exhibits according to
        user preference
      </p>
      <p>Application Scenario:&nbsp; AI recommendation</p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ten pieces of
        information have been collected
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>(2)</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>Derived information of user services</strong>
      </p>
      <p>Name of Information: Cookie content</p>
      <p>Application Purpose: Determining the login status</p>
      <p>Application Scenario:&nbsp; During the use of app by user</p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; One piece of
        information has been collected
      </p>
      <p>&nbsp;</p>
      <p>Name of Information: Search records</p>
      <p>
        Application Purpose: Displaying search records and personalized
        recommendation
      </p>
      <p>Application Scenario:&nbsp; When the user uses research services</p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ten pieces of
        information have been collected
      </p>
      <p>&nbsp;</p>
      <p><strong>4. </strong><strong>Device Information</strong></p>
      <p>Name of Information: Name of Device</p>
      <p>Application Purpose: Information acquisition</p>
      <p>Application Scenario:&nbsp; During the use of app by user</p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; One piece of
        information has been collected
      </p>
      <p>&nbsp;</p>
      <p>Name of Information: Device model</p>
      <p>Application Purpose: Information acquisition</p>
      <p>Application Scenario:&nbsp; During the use of app by user</p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; One piece of
        information has been collected
      </p>
      <!-- <p>&nbsp;</p>
      <p>Name of Information: MAC address</p>
      <p>Application Purpose: Information acquisition</p>
      <p>Application Scenario:&nbsp; Information acquisition</p>
      <p>Application Scenario:&nbsp; During the use of app by user</p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; One piece of
        information has been collected
      </p> -->
      <p>&nbsp;</p>
      <p>Name of Information: Operating system</p>
      <p>Application Purpose: Information acquisition</p>
      <p>Application Scenario:&nbsp; During the use of app by user</p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; One piece of
        information has been collected
      </p>
      <p>&nbsp;</p>
      <p>Name of Information: Version of app</p>
      <p>Application Purpose: Information acquisition</p>
      <p>Application Scenario:&nbsp; During the use of app by user</p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; One piece of
        information has been collected
      </p>
      <p>&nbsp;</p>
      <p>Name of Information: Resolution</p>
      <p>Application Purpose: Information acquisition</p>
      <p>Application Scenario:&nbsp; During the use of app by user</p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; One piece of
        information has been collected
      </p>
      <p>&nbsp;</p>
      <p>Name of Information: Serial number of device</p>
      <p>Application Purpose: Information acquisition</p>
      <p>Application Scenario:&nbsp; During the use of app by user</p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; One piece of
        information has been collected
      </p>
      <p>&nbsp;</p>
      <p>Name of Information: Information acquisition</p>
      <p>Application Purpose: Information acquisition</p>
      <p>Application Scenario:&nbsp; During the use of app by user</p>
      <p>
        Information Collected: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; One piece of
        information has been collected
      </p>
    </template>
    <template v-else>
      <h2 align="center">
        <strong>个人信息收集清单</strong>
      </h2>
      <p>
        为保障产品或服务能实现与安全稳定运行之目的，我们可能会收集您的以下个人信息：
      </p>
      <p>&nbsp;</p>
      <p><strong>1、 </strong><strong>用户基本信息</strong></p>
      <p>信息名称：姓名</p>
      <p>使用目的：授权个人实名，信息需求、数据分析、获取采购商订单信息</p>
      <p>
        使用场景：电子签约授权个人实名、意向订单、大数据分析时、展商&amp;展品信息展示时<em
        ></em>
      </p>
      <p>
        收集情况：已收集，1条&nbsp;
      </p>
      <p>&nbsp;</p>
      <p>信息名称：手机号码</p>
      <p>
        使用目的：创建账号、联系用户、数据分析、获取采购商订单信息
      </p>
      <p>
        使用场景：用户首次注册时、展商&amp;展品信息展示时、大数据分析时、展位销售联系时、电子签约联系时
      </p>
      <p>收集情况：已收集，1条</p>
      <p>&nbsp;</p>
      <p>信息名称：联系人邮箱</p>
      <p>使用目的：获取采购商订单信息、企业宣传</p>
      <p>使用场景：展商&amp;展品信息展示时、项目发布时</p>
      <p>收集情况：已收集，1条</p>
      <p>&nbsp;</p>
      <p>信息名称：地址</p>
      <p>使用目的：获取采购商订单信息</p>
      <p>使用场景：采购商订单信息确认时</p>
      <p>收集情况：已收集，1条</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p><strong>2、 </strong><strong>用户身份证明</strong></p>
      <p><strong>（1）&nbsp; </strong><strong>用户自然人身份信息</strong></p>
      <p>信息名称：证件类型及证件号</p>
      <p>使用目的：实名认证</p>
      <p>使用场景：电子签约时</p>
      <p>收集情况：已收集，1条</p>
      <p>&nbsp;</p>
      <p>
        <strong>（2）&nbsp; </strong><strong>用户虚拟身份和鉴权信息</strong>
      </p>
      <p>信息名称：账号及密码</p>
      <p>使用目的：创建账号</p>
      <p>使用场景：用户首次创建账号时、登录、找回密码、重置密码</p>
      <p>收集情况：已收集，1条</p>
      <p>&nbsp;</p>
      <p><strong>3、 </strong><strong>用户使用过程信息</strong></p>
      <p><strong>（1）&nbsp; </strong><strong>用户服务内容</strong></p>
      <p>信息名称：用户浏览展商、展品信息</p>
      <p>使用目的：根据用户偏好，推荐展商、展品</p>
      <p>使用场景：智能推荐</p>
      <p>收集情况：已收集，1条</p>
      <p>&nbsp;</p>
      <p><strong>（2）&nbsp; </strong><strong>用户服务衍生信息</strong></p>
      <p>信息名称： Cookie内容</p>
      <p>使用目的：判断登录状态</p>
      <p>使用场景：用户使用APP时</p>
      <p>收集情况：已收集，1条</p>
      <p>&nbsp;</p>
      <p>信息名称：搜索记录</p>
      <p>使用目的：展示搜索记录、个性化推荐</p>
      <p>使用场景：用户使用搜索服务时</p>
      <p>收集情况：已收集，1条</p>
      <p>&nbsp;</p>
      <p><strong>4、 </strong><strong>设备信息</strong></p>
      <p>信息名称：设备名称</p>
      <p>使用目的：对相应的产品或者服务内容进行排序以适应您的设备界面</p>
      <p>使用场景：用户使用APP时</p>
      <p>收集情况：已收集，1条</p>
      <p>&nbsp;</p>
      <p>信息名称：设备型号</p>
      <p>使用目的：对相应的产品或者服务内容进行排序以适应您的设备界面</p>
      <p>使用场景：用户使用APP时</p>
      <p>收集情况：已收集，1条</p>
      <!-- <p>&nbsp;</p>
      <p>信息名称：MAC地址</p>
      <p>使用目的：信息采集</p>
      <p>使用场景：信息采集</p>
      <p>使用场景：用户使用APP时</p>
      <p>收集情况：已收集，1条</p> -->
      <p>&nbsp;</p>
      <p>信息名称：操作系统</p>
      <p>使用目的：对相应的产品或者服务内容进行排序以适应您的设备界面</p>
      <p>使用场景：用户使用APP时</p>
      <p>收集情况：已收集，1条</p>
      <p>&nbsp;</p>
      <p>信息名称：应用程序版本</p>
      <p>使用目的：对相应的产品或者服务内容进行排序以适应您的设备界面</p>
      <p>使用场景：用户使用APP时</p>
      <p>收集情况：已收集，1条</p>
      <p>&nbsp;</p>
      <p>信息名称：分辨率</p>
      <p>使用目的：对相应的产品或者服务内容进行排序以适应您的设备界面</p>
      <p>使用场景：用户使用APP时</p>
      <p>收集情况：已收集，1条</p>
      <!-- <p>&nbsp;</p>
      <p>信息名称：设备序列号</p>
      <p>使用目的：信息采集</p>
      <p>使用场景：用户使用APP时</p>
      <p>收集情况：已收集，1条</p>
      <p>&nbsp;</p>
      <p>信息名称：信息采集</p>
      <p>使用目的：信息采集</p>
      <p>使用场景：用户使用APP时</p>
      <p>收集情况：已收集，1条</p> -->
    </template>
  </div>
</template>

<script>
import { getLang } from '@/utils'
export default {
  data() {
    return {
      locale: this.$route.query.lang == 'en' ? 'en-US' : '',
      lang: ''
    }
  },
  created() {
    this.lang = this.locale ? this.locale : getLang()
  }
}
</script>

<style lang="scss" scoped>
.rule-text-box {
  width: 1200px;
  margin: 20px auto;
  padding: 30px;
  background: #fff;
  font-size: 14px;
  line-height: 28px;
  h2 {
    margin: 0 0 32px;
    padding: 0 0 20px;
    border-bottom: 1px solid #eee;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }
  hr {
    margin: 20px 0;
  }
  a {
    color: #0175d4;
    text-decoration: underline;
  }
}
@media screen and (max-width: 800px) {
  .rule-text-box {
    width: 100%;
    margin: 0;
    padding: 15px;
    line-height: 28px;
    h2 {
      margin: 6px 0 10px;
      padding: 0;
      border-bottom: none;
      font-size: 20px;
      line-height: 36px;
    }
  }
}
</style>
